import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { enTokenCMD } from "../../../lib/classTalk/CodeEnum";
import { getSmartTVMediaTraceContext, setElementForGroupSmartTV, smartTVMediaTraceLog } from "../../../lib/MediaSoupClient";
import { addMediaError, videoErrorCodeToString } from "../../../lib/MediaErrorLog"; // 20260904 실제 재생 실패를 누적 오류 로그에 기록 ... by claude
import { xmitCmd_MessageForSmartTV } from "../../../lib/RabbitmqClient";
import { initFuncProcArr } from "../../../lib/rbmq/rcvMsgFromRbmq";

// import ConnectImg from "../../../images/connect.png";
// import ConnectImg from "../../../images/android_connect2.png";
// import NotConnectedImg from "../../../images/android_notconnected.png";
// import SharedCameraModeImg from "../../../images/android_shared_camera_mode.png";

const ConnectImgComp = styled.img`
    width : 100%;
    height : 100%;
`;

const VideoComp = ConnectImgComp.withComponent("video");

const SmartTVMediaSoupRcvForStd = forwardRef(({ idx, isModalOpened, userSeq, userNickname, liveSeq, isRbmqServerConnected, isReadyLiveConsume, isConnectedOnScreenApp, initViewMode, onSwitchView, handleSelectedFunc }, ref) => {
    const { t } = useTranslation();

    const isClientConnected = useRef(false);
    // const [isClientConnected, setIsClientConnected] = useState(false);

    // const lClassName = useRef(defaultClassName ? defaultClassName : "");
    // const [lPaddingLeftValue, setPaddingLeftValue] = useState("2px");
    // const [lLeftValue, setLeftValue] = useState("unset");
    // const [lRightValue, setRightValue] = useState(defaultRightValue ? defaultRightValue : "2px");
    // const [lTopValue, setTopValue] = useState("2px");
    // const [lWidth, setWidth] = useState("240px");
    // const [lHeight, setHeight] = useState("135px");
    // const [lZIndexValue, setZIndexValue] = useState(5);
    // const [lVisibility, setVisibility] = useState("visible");
    // const [lWidth, setWidth] = useState("100%");
    // const [lHeight, setHeight] = useState("100%");
    // const [lLeftValue, setLeftValue] = useState("2px");
    // const [lBottomValue, setBottomValue] = useState("2px");
    // const [lZIndexValue, setZIndexValue] = useState("unset");
    // const [lStyle, setStyle] = useState(style ? style : {
    //     position: 'absolute',
    //     right: '2px',
    //     top: '2px',
    //     width: '240px',
    //     height: '135px',
    //     paddingLeft: '2px',
    //     zIndex: 5,
    //     visibility: 'visible'
    // });

    const imageType = "image/webp";     // "image/jpeg"  "image/webp" ;

    const [lWidth, setWidth] = useState("240px");
    const [lHeight, setHeight] = useState("135px");
    const [lDisplay, setDisplay] = useState("block");
    const [lVideoDisplay, setVideoDisplay] = useState("block");
    const [lImageDisplay, setImageDisplay] = useState("none");

    const [lUserNickname, setUserNickname] = useState("");
    const [isMain, setIsMain] = useState(false);

    const videoEl = useRef(null);
    const audioEl = useRef(null);
    const imgEl = useRef(null);
    const sharedModeStarted = useRef(false);
    const viewMode = useRef("video");
    const previousScreenAppStateRef = useRef({ userSeq, isConnected: isConnectedOnScreenApp });
    // const sharedCameraMode = useRef(false);

    useImperativeHandle(ref, () => ({
        updateStdMediaView: value => updateView({
            ...value,
            userSeq,
            userNickname,
            liveSeq,
            isConnectedOnScreenApp
        }),
        getVisibility: () => { return lDisplay },
        // getVisibility: () => { return lVisibility },
        initConnectImg: () => setNotConnectedImg(),
        sendMessageToStd: value => {
            // console.log("sendMessageToStd - ", value, userSeq, liveSeq, isRbmqServerConnected, isConnectedOnScreenApp);
            // sendMessageToClient({ ...value, userSeq, liveSeq, isConnectedOnScreenApp });
            const { kind, isRbmqServerConnected } = value;
            console.log(`sendMessageToClient - kind[${kind}], userSeq[${userSeq}], liveSeq[${liveSeq}], isRbmqServerConnected[${isRbmqServerConnected}], isConnectedOnScreenApp[${isConnectedOnScreenApp}]`);
            if (kind === "TRY_CONN_APP") {
                if (isRbmqServerConnected) {
                    if (!isConnectedOnScreenApp) {
                        if (userSeq > -1 && liveSeq > -1) {
                            // let mode = lWidth.current === "100%" ? "image_full_mode" : "media_full_mode";
                            let mode = lWidth === "100%" ? true : false;
                            xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, mode);
                        }
                    }
                } else {
                    alert(t("스마트_티브이_안내_문구_13", { ns: "live" }));
                }
            } else if (kind === "TRY_DISCONN_APP") {
                if (isRbmqServerConnected) {
                    if (isConnectedOnScreenApp) {
                        if (userSeq > -1 && liveSeq > -1) {
                            xmitCmd_MessageForSmartTV("android", "ct_SmartTVLogout", enTokenCMD.NULL, userSeq, userNickname, liveSeq, false);
                        }
                    }
                } else {
                    alert(t("스마트_티브이_안내_문구_14", { ns: "live" }));
                }
            }
        },
        getDomNode : ()=> videoEl.current.parentNode,
    }), [t, userSeq, userNickname, liveSeq, isConnectedOnScreenApp, lDisplay]);

    const imageProcess = (status, data) => {
        // console.log("imageProcess - ", status, data);
        if (status === "connect") {
            console.log("rcv connect");
            sharedModeStarted.current = true;
            if (imgEl.current !== null) {
                imgEl.current.src = "/images/connect.png";
            } else {
                if (videoEl.current !== null) {
                    videoEl.current.pause();
                    videoEl.current.currentTime = 0;
                    videoEl.current.poster = "/images/connect.png";
                }
            }

            // setIsClientConnected(true);
            // isClientConnected.current = true;
            handleSelectedFunc({ selectedFunc: "CONNECTED_APP", idx, userSeq });
        } else if (status === "connect-client") {
            console.log("rcv connect-client");
            // let mode = true;
            // let mode = lWidth.current === "100%" ? true : false;
            let localStreamingMode;
            // let tvMode = lWidth.current === "240px" ? false : true;
            let tvMode = lWidth === "240px" ? false : true;
            if (lWidth === "240px") {
                localStreamingMode = 0;
                tvMode = false;
            } else if (lWidth === "100%") {
                localStreamingMode = 1;
                tvMode = true;
            } else {
                localStreamingMode = 4;
                tvMode = true;
            }

            console.log(`(1) userSeq[${userSeq}] - tvMode[${tvMode}], localStreamingMode[${localStreamingMode}]`);
            xmitCmd_MessageForSmartTV("smart_tv", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);

            if (!isConnectedOnScreenApp) {
                // mode = lWidth.current === "100%" ? true : false;
                // mode = lWidth === "100%" ? true : false;
                xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
            } else {
                xmitCmd_MessageForSmartTV("android", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
            }

            // setIsClientConnected(true);
            isClientConnected.current = true;
        } else if (status === "disconnect") {
            console.log("rcv disconnect");
            if (imgEl.current !== null) {
                imgEl.current.src = "/images/connect.png";
                // imgEl.current.src = "/images/android_notconnected.png";
            } else {
                if (videoEl.current !== null) {
                    videoEl.current.pause();
                    videoEl.current.currentTime = 0;
                    videoEl.current.poster = "/images/connect.png";
                    // videoEl.current.poster = "/images/android_notconnected.png";
                }
            }

            isClientConnected.current = false;
            handleSelectedFunc({ selectedFunc: "DISCONN_APP", idx, userSeq });
        } else if (status === "update") {
            if (imgEl.current) {
                if (data !== undefined && data !== null) {
                    if (imgEl.current.complete) {   // draw가 완전히 끝난 경우에만 그려주게 처리 ... (by shlee from pentalk wifi) 20240610
                        let blob = new Blob([data], { type: imageType });
                        let reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onload = () => {
                            imgEl.current.src = reader.result;
                            blob = null;
                        };
                    }
                } else {
                    imgEl.current.src = "/images/connect.png";
                }
            } else {
                if (videoEl.current) {
                    if (data !== undefined && data !== null) {
                        // if (videoEl.current.complete) {     // draw가 완전히 끝난 경우에만 그려주게 처리 ... (by shlee from pentalk wifi) 20240610
                            let blob = new Blob([data], { type: imageType });

                            let reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = () => {
                                videoEl.current.pause();
                                videoEl.current.currentTime = 0;
                                videoEl.current.poster = reader.result;
                                blob = null;
                            };
                        // }
                    } else {
                        videoEl.current.pause();
                        videoEl.current.currentTime = 0;
                        videoEl.current.poster = "/images/connect.png";
                    }
                }
            }
        } else if (status === "shared-screen-mode") {
            // console.log("rcv shared-screen-mode");
            sharedModeStarted.current = true;
            // sharedCameraMode.current = false;
        } else if (status === "shared-camera-mode") {
            // console.log("rcv shared-camera-mode");
            sharedModeStarted.current = false;
            // sharedCameraMode.current = true;
        } else if (status === "shared-stop-mode") {
            //console.log("rcv shared-stop-mode");
            sharedModeStarted.current = false;
            if (imgEl.current !== null) {
                imgEl.current.src = "/images/connect.png";
            } else {
                if (videoEl.current !== null) {
                    videoEl.current.pause();
                    videoEl.current.currentTime = 0;
                    videoEl.current.poster = "/images/connect.png";
                }
            }
        } else if (status === "media_full_mode" || status === "image_mode") {
            // console.log("rcv ", status);
            initViewMode({ kind: "media_full_mode", idx, userSeq });
        } else if (status === "image_full_mode" || status === "video_mode") {
            // console.log("rcv ", status);
            onSwitchView({ kind: "image_full_mode", idx, userSeq });
        } else if (status === "update_view_mode") {
            // console.log("rcv ", status);
            viewMode.current = status;
        } /* else if (status === "video_mode") {
            onSwitchView({ kind: "image_full_mode", idx, userSeq });
        } else if (status === "image_mode") {
            onSwitchView({ kind: "media_full_mode", idx, userSeq });
        } */
    }

    useEffect(() => {
        return () => {
            imgEl.current = null;
            videoEl.current = null;
            audioEl.current = null;

            initFuncProcArr(idx, -1, null);
            // xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, false);
            console.log("useEffect return => ", userSeq, userNickname, liveSeq, isRbmqServerConnected, isConnectedOnScreenApp);
            xmitCmd_MessageForSmartTV("android", "ct_SmartTVLogout", enTokenCMD.ct_Logout, userSeq, userNickname, liveSeq, false);
        }
    }, []);

    useEffect(() => {
        console.log(`(1) useEffect(SmartTVMediaSoupRcvForStd) - idx[${idx}], userSeq[${userSeq}]]`);

        if (userSeq > -1 && idx > -1) {
            initFuncProcArr(idx, userSeq, imageProcess);
        }
    }, [idx, userSeq]);

    useEffect(() => {
        console.log(`(2) useEffect(SmartTVMediaSoupRcvForStd) - idx[${idx}], userSeq[${userSeq}], isRbmqServerConnected[${isRbmqServerConnected}], isReadyLiveConsume[${isReadyLiveConsume}]`);

        if (!isModalOpened) {
            if (isRbmqServerConnected && isReadyLiveConsume) {
                if (userSeq > -1 && idx > -1) {
                    setElementForGroupSmartTV(idx, userSeq, videoEl.current, audioEl.current);
                }
            }
        }
    }, [idx, userSeq, isModalOpened, isRbmqServerConnected, isReadyLiveConsume]);

    // 260805 Phase 2 진단: 학생 <video> 실제 재생 상태를 계측한다. 로그만 남기고 재생 동작/화면은 바꾸지 않는다.
    const lastVideoTraceStateRef = useRef(null);
    useEffect(() => {
        const videoNode = videoEl.current;
        if (!videoNode) return undefined;

        // 260805 인덱스 기반 컴포넌트가 다른 학생으로 재사용될 때 이전 학생의 마지막 상태를 이어받지 않는다.
        lastVideoTraceStateRef.current = null;

        const getTraceFields = () => ({
            ...getSmartTVMediaTraceContext(userSeq),
            idx
        });

        const traceIfChanged = stage => {
            if (lastVideoTraceStateRef.current === stage) return; // 같은 상태 반복 출력 방지
            lastVideoTraceStateRef.current = stage;
            smartTVMediaTraceLog(stage, getTraceFields());
        };

        const onLoadedMetadata = () => traceIfChanged("VIDEO_LOADEDMETADATA");
        const onLoadedData = () => traceIfChanged("VIDEO_LOADEDDATA");
        const onCanPlay = () => traceIfChanged("VIDEO_CANPLAY");
        const onPlaying = () => traceIfChanged("VIDEO_PLAYING");
        const onWaiting = () => traceIfChanged("VIDEO_WAITING");
        const onStalled = () => traceIfChanged("VIDEO_STALLED");
        const onError = () => {
            // error는 상태가 겹쳐도 매번 기록한다(반복 실패를 놓치지 않기 위함).
            const mediaError = videoNode.error;
            smartTVMediaTraceLog("VIDEO_ERROR", { ...getTraceFields(), code: mediaError && mediaError.code, message: mediaError && mediaError.message });
            // 20260904 진단 트레이스는 운영에서 꺼져있을 수 있으므로 별도로 누적 오류 로그에도 기록한다 ... by claude
            addMediaError({
                roomKind: "handsup",
                mediaKind: "video",
                prodUserSeq: userSeq,
                errorCode: videoErrorCodeToString(mediaError && mediaError.code)
            });
        };

        videoNode.addEventListener("loadedmetadata", onLoadedMetadata);
        videoNode.addEventListener("loadeddata", onLoadedData);
        videoNode.addEventListener("canplay", onCanPlay);
        videoNode.addEventListener("playing", onPlaying);
        videoNode.addEventListener("waiting", onWaiting);
        videoNode.addEventListener("stalled", onStalled);
        videoNode.addEventListener("error", onError);

        return () => {
            videoNode.removeEventListener("loadedmetadata", onLoadedMetadata);
            videoNode.removeEventListener("loadeddata", onLoadedData);
            videoNode.removeEventListener("canplay", onCanPlay);
            videoNode.removeEventListener("playing", onPlaying);
            videoNode.removeEventListener("waiting", onWaiting);
            videoNode.removeEventListener("stalled", onStalled);
            videoNode.removeEventListener("error", onError);
        };
    }, [userSeq, idx]);

    useEffect(() => {
        console.log(`(3) useEffect(SmartTVMediaSoupRcvForStd) - userSeq[${userSeq}], isConnectedOnScreenApp[${isConnectedOnScreenApp}], isRbmqServerConnected[${isRbmqServerConnected}], isReadyLiveConsume[${isReadyLiveConsume}], lWidth[${lWidth}]`);

        if (!isModalOpened) {
            if (isRbmqServerConnected && isReadyLiveConsume) {
                if (userSeq > -1 && liveSeq > -1) {
                    /* if (!isConnectedOnScreenApp) {
                        if (userSeq > -1 && liveSeq > -1) {
                            // let mode = lWidth.current === "100%" ? "image_full_mode" : "media_full_mode";
                            let mode = lWidth.current === "100%" ? true : false;
                            xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, mode);
                        }
                    } */

                    // let mode = true;
                    let localStreamingMode;
                    // let tvMode = lWidth.current === "240px" ? false : true;
                    let tvMode = lWidth === "240px" ? false : true;
                    if (lWidth === "240px") {
                        localStreamingMode = 0;
                        tvMode = false;
                    } else if (lWidth === "100%") {
                        localStreamingMode = 1;
                        tvMode = true;
                    } else {
                        localStreamingMode = 4;
                        tvMode = true;
                    }

                    console.log(`(2) userSeq[${userSeq}] - tvMode[${tvMode}], localStreamingMode[${localStreamingMode}]`);
                    xmitCmd_MessageForSmartTV("smart_tv", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);

                    if (!isConnectedOnScreenApp) {
                        // mode = lWidth.current === "100%" ? true : false;
                        // mode = lWidth === "100%" ? true : false;

                        xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
                    } else {
                        xmitCmd_MessageForSmartTV("android", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
                    }
                }
            }
        }
    }, [isModalOpened, isRbmqServerConnected, isReadyLiveConsume, isConnectedOnScreenApp, userSeq, userNickname, liveSeq, lWidth]);

    useEffect(() => {
        // 20260806 실제 학생 화면앱의 연결 해제만 진단 상태에 반영하고 최초 미접속 상태는 제외한다.
        const previousState = previousScreenAppStateRef.current;
        if (previousState.userSeq === userSeq && previousState.isConnected === true && isConnectedOnScreenApp === false && userSeq > -1) {
            smartTVMediaTraceLog("STUDENT_DISCONNECTED", {
                ...getSmartTVMediaTraceContext(userSeq),
                idx
            });
        }
        previousScreenAppStateRef.current = { userSeq, isConnected: isConnectedOnScreenApp };
    }, [idx, isConnectedOnScreenApp, userSeq]);

    useEffect(() => {
        console.log("(4) useEffect(SmartTVMediaSoupRcvForStd) idx[", idx, "], userNickname[", userNickname, "]");

        if (userNickname && userNickname !== "") {
            setUserNickname(userNickname);
        }/*  else {
            if (idx !== undefined) {
                let number = idx.toString().padStart(2, "0");
                setUserNickname("HiNote " + number);
            } else {
                setUserNickname("HiNote 00");
            }
        } */
    }, [idx, userNickname]);

    const updateView = ({ userSeq, userNickname, liveSeq, isConnectedOnScreenApp, className, width, height, display, zIndex, visibility, isImageViewToggle }) => {
        console.log(`userSeq[${userSeq}], userNickname[${userNickname}], liveSeq[${liveSeq}], width[${width}], height[${height}], isConnectedOnScreenApp[${isConnectedOnScreenApp}]`);
        // let msg = `updateView - className[${className}], lWidth[${lWidth.current}], width[${width}]`;
        // msg += `, display[${display}], zIndex[${zIndex}], visibility[${visibility}], isImageViewToggle[${isImageViewToggle}]`;
        // console.log(msg);
        // if (width) setWidth(width);
        if (width) {
            // lWidth.current = width;
            setWidth(width);
            setHeight(height);

            let localStreamingMode;
            // let tvMode = lWidth.current === "240px" ? false : true;
            let tvMode = lWidth === "240px" ? false : true;
            if (width === "240px") {
                localStreamingMode = 0;
                tvMode = false;
                setIsMain(false);
            } else if (width === "100%") {
                localStreamingMode = 1;
                tvMode = true;
                setIsMain(true);
            } else {
                localStreamingMode = 4;
                tvMode = true;
                setIsMain(false);
            }
            console.log("isMain[", isMain, "]");

            console.log(`(3) userSeq[${userSeq}] - tvMode[${tvMode}], localStreamingMode[${localStreamingMode}]`);
            xmitCmd_MessageForSmartTV("smart_tv", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);

            if (isConnectedOnScreenApp) {
                xmitCmd_MessageForSmartTV("android", "ct_SwitchStudentVideoResolution", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
            } else {
                xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, tvMode, localStreamingMode);
            }
        }

        // console.log(`lWidth[${lWidth.current}], width[${width}]`);
        // console.log(`lDisplay[${lDisplay}], display[${display}]`);
        if (width !== "100%") {
            if (display) setDisplay(display);
        } else {
            if (width === "100%") {
                setDisplay("block");
                // if (zIndex) setZIndexValue(zIndex);
            } else {
                // console.log("width is 100%. don't update visibility.");
            }
        }

        /* if (lWidth.current !== "100%") {
            if (display) setDisplay(display);
            // if (zIndex) setZIndexValue(zIndex);
        } else {
            console.log("lWidth.current is 100%. don't update visibility.");
        } */
    }

    const setNotConnectedImg = () => {
        if (imgEl.current) {
            imgEl.current.src = "/images/connect.png";
            // imgEl.current.src = "/images/android_notconnected.png";
        } else {
            if (videoEl.current !== null) {
                videoEl.current.pause();
                videoEl.current.currentTime = 0;
                videoEl.current.poster = "/images/connect.png";
                // videoEl.current.poster = "/images/android_notconnected.png";
            }
        }
    }

    const onClickView = () => {
        console.log("onClickView - userSeq[", userSeq, "], lWidth[", lWidth, "]");

        if (userSeq > -1) {
            if (idx !== undefined && idx !== null) {
                if (lWidth !== "100%") {
                    onSwitchView({ kind: "image_full_mode", idx, userSeq });
                }
            } else {
                if (lWidth === "100%") {
                    onSwitchView({ kind: "media_full_mode", idx, userSeq });
                } else {
                    onSwitchView({ kind: "image_full_mode", idx, userSeq });
                }
            }
        }
    }

    const sendMessageToClient = ({ kind, userSeq, liveSeq, isConnectedOnScreenApp, isRbmqServerConnected }) => {
        console.log(`sendMessageToClient - kind[${kind}], userSeq[${userSeq}], liveSeq[${liveSeq}], isRbmqServerConnected[${isRbmqServerConnected}], isConnectedOnScreenApp[${isConnectedOnScreenApp}]`);
        if (kind === "TRY_CONN_APP") {
            if (isRbmqServerConnected) {
                if (!isConnectedOnScreenApp) {
                    if (userSeq > -1 && liveSeq > -1) {
                        // let mode = lWidth.current === "100%" ? "image_full_mode" : "media_full_mode";
                        // let mode = lWidth.current === "100%" ? true : false;
                        let mode = lWidth === "100%" ? true : false;
                        xmitCmd_MessageForSmartTV("android", "ct_RequestUpdateImageForSmartTV", enTokenCMD.NULL, userSeq, userNickname, liveSeq, mode);
                    }
                }
            } else {
                alert(t("스마트_티브이_안내_문구_13", { ns: "live" }));
            }
        } else if (kind === "TRY_DISCONN_APP") {
            if (isRbmqServerConnected) {
                if (isConnectedOnScreenApp) {
                    if (userSeq > -1 && liveSeq > -1) {
                        xmitCmd_MessageForSmartTV("android", "ct_SmartTVLogout", enTokenCMD.NULL, userSeq, userNickname, liveSeq, false);
                    }
                }
            } else {
                alert(t("스마트_티브이_안내_문구_14", { ns: "live" }));
            }
        }
    }

    return (
        <div
            ref={ref}
            className={isMain ? "mediasoup-comp-container main-view" : ""}
            style={{ position: isMain ? "fixed" : "relative", display: `${lDisplay}`, margin: isMain ? "0px" : "0px 1px" }}
            onClick={onClickView}
        >
            <VideoComp key={"mediasoup-video-comp-" + userSeq} id={"mediasoup-video-comp-" + userSeq} ref={videoEl} className="mediasoup-comp" style={{ display: `${lVideoDisplay}`, width: `${lWidth}`, height: `${lHeight === "100%" ? "calc(100vh - 50px)" : lHeight}` }} poster="/images/connect.png" playsInline autoPlay muted />
            {/* <ConnectImgComp id={"mediasoup-img-comp-" + userSeq} ref={imgEl} className="mediasoup-comp" style={{ display: `${lImageDisplay}` }} src="/images/connect.png" alt="" /> */}
            {
                lUserNickname && lUserNickname !== "" &&
                <span className="mediasoup-comp">{lUserNickname}</span>
            }
            <audio key={"mediasoup-audio-comp-" + userSeq} id={"mediasoup-audio-comp-" + userSeq} ref={audioEl} style={{ display: 'none' }} autoPlay />
        </div>
    );
});

export default SmartTVMediaSoupRcvForStd;
